<template>
    <div>
        <div class="page-filter_wrap">
            <div class="page-filter_wrap_left">
                <el-input placeholder="请输入姓名/权限内容" v-model="searchForm.keyword" class="filter-input" clearable :autofocus="true">
                    <i slot="suffix" class="iconfont icon-sousuo"></i>
                </el-input>
            </div>
            <div class="page-filter_wrap_right">
                <el-button type="primary" @click="handleClickAuthoriedAdd">新增权限</el-button>
            </div>
        </div>

        <CustomVxeTable id="customTable2" ref="customTable2" :tableData="tableData2" :reduceHeight="170" :showPagination="false">
            <vxe-column field="name" title="授权人员" min-width="393" show-overflow>
                <template #default="{ row }">
                    <span>{{ row.name }}</span>
                </template>
            </vxe-column>
            <vxe-column field="count" title="授权人数（人）" align="right" min-width="177" show-overflow>
                <template #default="{ row }">
                    <span>12</span>
                </template>
            </vxe-column>
            <vxe-column field="permission" title="权限范围" min-width="541" show-overflow>
                <template #default="{ row }">
                    <span>查看权限</span>
                </template>
            </vxe-column>
            <vxe-column field="operate2" title="操作" width="146" fixed="right">
                <template #default="{ row }">
                    <el-button type="text" @click="handleClickAuthor(row)">授权</el-button>
                    <el-button type="text" @click="handleClickAuthoriedEdit(row)">编辑</el-button>
                    <el-button type="text" class="warn-text" @click="handleClickAuthorDelete(row)">删除</el-button>
                </template>
            </vxe-column>
        </CustomVxeTable>
        <AuthorizedPersonnel ref="AuthorizedPersonnel" :authorizedPersonnelVisible.sync="authorizedPersonnelVisible" @selectAuthorizedData="handleSelectAuthorizedData" v-if="authorizedPersonnelVisible" />
        <AuthorizedOperator ref="AuthorizedOperator" :authorizedOperatorVisible.sync="authorizedOperatorVisible" :userId.sync="authorizedUserId" :authorizedPersonnelData.sync="authorizedPersonnelData" @selectAuthor="handleClickAuthor" v-if="authorizedOperatorVisible" />
        <el-dialog title="" :visible.sync="deletePermissionDialog" width="390px" :before-close="handledeletePermissionDialogClose" :close-on-click-modal="false"
            class="custom-dialog custom-tooltip-confirm-dialog">
            <div class="flex">
                <i class="dialog-left-icon iconfont icon-jinggao"></i>
                <div>
                    <p class="tooltip-confirm-title">
                        确定要删除该权限吗？
                    </p>
                    <p>删除后，该权限的授权人员也将被删除，可能无法使用相关功能！</p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handledeletePermissionDialogClose">取消</el-button>
                <el-button type="danger" @click="handledeletePermissionDialogConfirm">移除</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import CustomVxeTable from "@/components/pComponents/vxe-table";
import AuthorizedPersonnel from "./component/authorized_personnel.vue";
import AuthorizedOperator from "./component/authorized_operator.vue";
export default {
    name: "MemberPermissions",
    components: { CustomVxeTable, AuthorizedPersonnel, AuthorizedOperator },
    data() {
        return {
            searchForm: {
                keyword: ""
            },
            tableData2: [
                {
                    name: "张三",
                    dTitle: "人事行政部",
                    createTime: "2024-09-20 15:30"
                }
            ],
            authorizedPersonnelVisible: false,
            authorizedOperatorVisible: false,
            authorizedUserId: "",
            authorizedPersonnelData: {},
            deletePermissionDialog: false,

        }
    },
    methods: {
        handleClickAuthor() {
            this.authorizedPersonnelVisible = true
        },
        handleClickAuthoriedAdd() {
            this.authorizedUserId = ""
            this.authorizedOperatorVisible = true
        },
        handleClickAuthoriedEdit(row) {
            this.authorizedUserId = 1
            this.authorizedOperatorVisible = true
        },
        // 选择的人员数据
        handleSelectAuthorizedData(data) {
            this.authorizedPersonnelData = data
        },
        handleClickAuthorDelete(row) {
            this.deletePermissionDialog = true
        },
        handledeletePermissionDialogClose() {
            this.deletePermissionDialog = false
        },
        handledeletePermissionDialogConfirm() {
            this.deletePermissionDialog = false
        }
    }
}
</script>
<style lang="scss">
.vxe-table {
    .el-button--text + .el-button--text {
        margin-left: 16px;
        position: relative;
        &::before {
            content: "";
            position: absolute;
            left: -8px;
            width: 1px;
height: 16px;
opacity: 1;
background: #E8E8E8;
        }
    }

}
</style>
